import List from './list.vue';
import Full from '@rebuild/materials/shared/custom/Full.vue';

export const componentMap = {
	list: List,
	full: Full
};
